import React from 'react';
import PropTypes from 'prop-types';
import DropdownBase from './DropdownBase';

class Dropdown extends React.Component {
  static propTypes = {
    /** Classname to be applied to Dropdown */
    className: PropTypes.string,
    /** Callback fired when Change event is called */
    onChange: PropTypes.func.isRequired,
    /** If `true`, Dropdown will be Disabled */
    isDisabled: PropTypes.bool,
    /** If `true`, Dropdown will show loader till the data is loaded */
    isLoading: PropTypes.bool,
    /** If `true`, Dropdown will show cross icon to delete the value*/
    isClearable: PropTypes.bool,
    /** If `true`, Dropdown will autoSearch for the records value*/
    isSearchable: PropTypes.bool,
    /** It will show label for the dropdown*/
    label: PropTypes.string.isRequired,
    /** Function to override default value rendering */
    renderValue: PropTypes.func,
    /** Function to override default filtering */
    onFilter: PropTypes.func,
    /** Default value to seed uncontrolled component */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Function to override default arrowRenderer */
    renderIcon: PropTypes.func,
    /** If `true`, Dropdown border to be shown in red color */
    hasError: PropTypes.bool,
  };

  getStyles = type => {
    switch (type) {
      case 'profile':
        return {
          root: {
            maxWidth: '520px',
          },
          floatLabel: {
            position: 'absolute',
            top: 'calc(50% - 8px)',
            left: '16px',
            transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
            transformOrigin: 'top left',
            fontSize: '1rem',
            // fontFamily: "EYInterstate"
          },
          floatLabelShrink: {
            left: '12px',
            fontSize: '0.7em',
            top: '12px',
          },
          '@global': {
            '.Select-arrow-zone': {
              right: '6px',
              // transform: 'translateY(calc(-25%))',
              // '-ms-transform': 'translateY(-25%)',
              // '-webkit-transform': 'none',
              transform: 'none',
            },
            '.StyledComponent-floatLabel-240': {
              left: '17px',
            },
            '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
              padding: '0px 0px 0px 15px',
              fontSize: '1rem',
              color: 'grey',
            },
          },
        };
      case 'registration':
        return {
          root: {
            maxWidth: '520px',
          },
        };
      case 'casesFilter':
        return {
          root: {
            width: 200,
            height: '48px',
            backgroundColor: '#F6F6FA',
            maxWidth: '200px',
            overflow: 'hidden',
            border: 'none'
          },
          labelPlaceholder: {
            height: '0px',
          },
          enableDropdownField: {
            borderBottom: 'none',
            '&:hover, &:focus-within': {
              background: '#F6F6FA',
              borderBottom: 'none',
            },
          },
          floatLabel: {
            fontFamily: '"EYInterstate", sans-serif',
            transition: 'none',
            color: 'rgba(0, 0, 0, 0.54)',
            paddingLeft: '8px',
            fontSize: '0.75rem',
            top: '0px',
            left: '0px',
            transform: 'none',
          },
          floatLabelShrink: {
            transition: 'none',
            transform: 'none',
            fontSize: '0.75rem',
            color: '#747480',
          },
          '@global': {
            '.Select': {
              width: '100%',
              height: '100%',
            },
            '.Select-arrow-zone': {
              top: '0',
            },
            '.Select-input': {
              marginLeft: '10px',
              marginTop: '16px',
              height: 'auto',
            },
            '.Select-control':{
              cursor:'text',
              border: '1px solid transparent'
            },
            '.Select-value': {
              marginLeft: '0px',
              paddingTop: '16px',
              lineHeight: '32px !important',
              fontFamily: '"EYInterstate", sans-serif',
            },
            '.Select-option.is-selected': {
              backgroundColor: '#E1E1E6',
            },
            '.Select.is-focused:not(.is-open) > .Select-control, .Select.is-focused > .Select-control': {
              boxShadow: 'none',
              background: '#F6F6FA !important',
              border: '1px solid #C4C4CE',
              borderRadius:'0px'
            },
            '.Select-menu div':{
              fontFamily: '"EYInterstate", sans-serif',
              fontColor: '#000000 !important'
            },
            '.Select-menu-outer': {
              borderRadius: '4px'
            }
        }};
      default:
        return {};
    }
  };

  getSettings = type => {
    switch (type) {
      default:
        return {
          renderIcon: () => null,
          renderOption: (data, searchText) => {
            const highlight = (needle, haystack) => haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);
            const labelText = data.label !== null && data.label.length >= 1 ? highlight(searchText, data.label) : '';
            //pass additional info true if we want email beneath name
            if(this.props.additionalInfoDropdown){
            return (
              //add padding as we have removed padding in dropdownbase 'select-option'
              <div className="autocomplete-item-wrapper additional-info-new-dropdown" id={data.id}
              style={{padding:'10px', display: (data.name==="delegatecontact" && (data.isActive || data.email === "")) && 'none'}}>
                <div>
                <span className="autocomplete-item-name availableData" dangerouslySetInnerHTML={{ __html: labelText }}/>
                {data.isAvailable && <span className='availableCaseContact'>, {data.isAvailable}</span>}
                {data.email && <p className='availableEmail'>{data.email}</p>}
                </div>
              </div>
            );
            }
            else {
              return(
                //add padding as we have removed padding in dropdownbase 'select-option'
              <div style={{padding:'12px'}} className="autocomplete-item-wrapper">
                <div className="autocomplete-item-name" dangerouslySetInnerHTML={{ __html: labelText }} />
              </div>
              )
            }
          },
          renderValue: conf => {
            const { value, disabled } = conf;
            return (
              <div className="Select-value">
                <span style={{ color: !disabled ? 'black' : '#aa9fa2' }}>{value.label}</span>
                {/*add line just for unavailable message */}
                {this.props.additionalInfoDropdown && value.isAvailable && <span className='availableCaseContact'>, {value.isAvailable}</span>}
              </div>
            );
          },
        };
    }
  };

  render() {
    const { styleType } = this.props;
    const styles = this.getStyles(styleType);
    const settings = this.getSettings(styleType);

    return <DropdownBase {...settings} styles={styles} {...this.props} />;
  }
}

export default Dropdown;
